//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

const getShouldRefreshFbConnection = createSelector(
  (state: ICuralateStore) => state.facebookInstagramSettings.facebookUserToken,
  (state: ICuralateStore) => state.facebookInstagramSettings.connectedFacebookPageToken,
  (userToken, pageToken) => {
    const isUserTokenInvalid = userToken?.isExpired || userToken?.isValid === false;
    const isPageTokenInvalid = pageToken?.isExpired || pageToken?.isValid === false || pageToken?.isDataAccessExpired;
    return isUserTokenInvalid || isPageTokenInvalid;
  },
);

export default getShouldRefreshFbConnection;
